import HTMLTemplate from './template.html'
import authClient from '../../modules/oktaAuth'

export const LogoutModalComponent = (() => {
    const vueComponent = {
        data() {
            return {
                isLoading: false,
                show: false
            }
        },
        methods: {
            logout() {
                this.isLoading = true

                try {
                    window.sessionStorage.removeItem('alert-management-session-shown')
                } catch (e) { /* ignore */ }

                authClient.signOut()
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-modal-logout')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})()
